import {cloneDeep} from "lodash";
import {getArray, getString, resetObjectValues} from 'Core/helpers/data';
import {CustomerSegmentsItemDataObject} from "../dataObjects";
import * as conditionDataMap from 'DataMaps/conditions/condition';
import {COMPARATOR} from 'Core/const/global';

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerSegmentsItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerSegmentsItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getArray(result, 'projectIds').map(pId => `${pId}`),
		getArray(result, 'conditions')
			// Split value of the BTW (between) comparator into an array using a comma as a separator (,)
			.map(c => c.comparisonOperator === COMPARATOR.BTW ? {...c, operand2: c.operand2.split(',')} : c)
			// Map condition data for input
			.map(c => conditionDataMap.input(c)),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {CustomerSegmentsItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		id: inputData.id,
		name: inputData.name,
		projectIds: getArray(inputData, 'projectIds').map(pId => +pId),
		conditions: getArray(inputData, 'conditions')
			// Join value of the BTW (between) comparator into a string using a comma as a separator (,)
			.map(c => c.comparator === COMPARATOR.BTW ? 
				{...c, value: (Array.isArray(c.value) ? c.value.join(',') : c.value)} : 
				c
			)
			// Map condition data for output and set the ordinal according to the condition index in the list
			.map((c, idx) => ({...conditionDataMap.output(c), ordinal: idx + 1}))
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}